import { GET } from "../../API/get";

export const findRequestDetails = async (job_id, undecided) => {
    const query = undecided ? "?undecided=1" : "";
    const URL = `job/ftm/all-requests/${job_id}/${query}`;
    
    try {
        const response = await GET(URL);
        return response?.status === "Success" ? response : null;
    } catch (error) {
        console.error("Error fetching request details:", error);
        return null;
    }
};